import { IdleWarningDialog } from "./idle-warning-dialog";
import { SessionController } from "./session-controller";
import { useIdleLogout } from "./use-idle-logout";

/**
 * IR-1241 — mount once inside the authenticated subtree (/_authed). Combines:
 *  - SessionController: reactive redirect to /login the instant auth is cleared
 *    (expired refresh, idle timeout, or manual sign-out), no manual reload.
 *  - the inactivity idle timer + its countdown warning modal.
 */
export function SessionGuard() {
  const idle = useIdleLogout();
  return (
    <>
      <SessionController />
      <IdleWarningDialog
        open={idle.warningActive}
        remainingMs={idle.remainingMs}
        onStay={idle.stayActive}
        onLogout={idle.logoutNow}
      />
    </>
  );
}
